// client/src/services/publicEventApi.js
// The public (unauthenticated) event-page endpoints + the authenticated
// publish control. On-Screen 2.0 first-class public event pages.

import axios from 'axios';
import { patchJson } from './http';

const BASE = (process.env.REACT_APP_BASE_URL || window.location.origin || '').replace(/\/+$/, '');

/** Public: the event page payload. No auth. */
export async function fetchPublicEvent(tenantSlug, eventSlug) {
  const { data } = await axios.get(`${BASE}/api/public/events/${encodeURIComponent(tenantSlug)}/${encodeURIComponent(eventSlug)}`);
  return data;
}

/** Public: a tenant's listed (public-visibility) events. */
export async function fetchPublicEventList(tenantSlug) {
  const { data } = await axios.get(`${BASE}/api/public/tenants/${encodeURIComponent(tenantSlug)}/events`);
  return data;
}

/** Authenticated: publish / update / unpublish the public page for one event. */
export async function updateEventPublicPage(tenantId, eventId, payload) {
  return patchJson(`/api/events/${tenantId}/events/${eventId}/public`, payload);
}

export const PUBLIC_VISIBILITY = ['private', 'unlisted', 'public'];
export const VISIBILITY_LABELS = {
  private: 'Private — page is off',
  unlisted: 'Unlisted — anyone with the link',
  public: 'Public — link + listed',
};
